import { render, staticRenderFns } from "./LoginPageTemplate.vue?vue&type=template&id=19c50803&scoped=true&"
import script from "./LoginPageTemplate.vue?vue&type=script&lang=js&"
export * from "./LoginPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageTemplate.vue?vue&type=style&index=0&id=19c50803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c50803",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
